import React from 'react';
import PropTypes from 'prop-types';
import { Form, reduxForm } from 'redux-form';

import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';

import { Switch, Button, Stars, Grid } from '../';
import { CHECKBOX, STARS } from '../../../constants/questionTypes';

const ChoiceForm = reduxForm({ form: 'choice-form' })(
  ({ children, styles, handleSubmit, header, button, questions, pageName }) => (
    <Form onSubmit={handleSubmit} className={styles['options']}>
      <div className={styles['options__content']}>
        {children}
        {header ? (
          <h2 className={styles['options__header']}>{header}</h2>
        ) : null}
        <div style={{ padding: '4px' }}>
          <Grid
            container
            direction="column"
            spacing={1}
            className={styles['options__questions']}
          >
            {questions &&
              questions.length &&
              questions.map(({ text, id, type }, ind) => (
                <Grid item className={styles['options__question']} key={id}>
                  {(() => {
                    switch (type) {
                      case CHECKBOX:
                        return (
                          <Switch
                            color="primary"
                            name={id}
                            id={`page.${pageName}.component.switch-${id}`}
                          />
                        );
                      case STARS:
                        return (
                          <Stars
                            name={id}
                            id={`page.${pageName}.component.stars-${id}`}
                            starCount={5}
                            starColor="#FD4"
                            emptyStarColor="#999"
                            renderStarIcon={(item, value) =>
                              item <= value ? (
                                <StarIcon
                                  id={`page.${pageName}.component.stars-${id}-${item}`}
                                  className={styles['options__question-star']}
                                />
                              ) : (
                                <StarBorderIcon
                                  id={`page.${pageName}.component.stars-${id}-${item}`}
                                  className={styles['options__question-star']}
                                />
                              )
                            }
                          />
                        );
                      default:
                        return null;
                    }
                  })()}
                  <div className={styles['options__question-text']}>{text}</div>
                </Grid>
              ))}
          </Grid>
        </div>
        {!header && children ? (
          <div className={styles['options__placeholder']} />
        ) : null}
      </div>
      {button ? (
        <Button
          id={`page.${pageName}.component.choice-form.send-button`}
          className={styles['options__button']}
          type="submit"
        >
          {button}
        </Button>
      ) : null}
    </Form>
  )
);

ChoiceForm.propTypes = {
  children: PropTypes.node,
  styles: PropTypes.object,
  onSubmit: PropTypes.func,
  header: PropTypes.string,
  button: PropTypes.string,
  questions: PropTypes.array,
  pageName: PropTypes.string,
};

export default ChoiceForm;
